import moment from 'moment';

/**
 * The time slot search window for a calendar month: every day the month grid
 * shows, including the leading and trailing days of the neighbouring months.
 * The window never starts in the past.
 */
export const monthWindow = (month, now = moment()) => {
  const firstVisibleDay = month.clone().startOf('month').startOf('week');
  return {
    from: firstVisibleDay.isBefore(now) ? now.clone() : firstVisibleDay,
    to: month.clone().endOf('month').endOf('week')
  };
};

export default monthWindow;



// WEBPACK FOOTER //
// ./src/util/timeSlotWindow.js